import Vue from 'vue'
import VueRouter from 'vue-router'
import { Message }from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import Login from '../views/Login';
import Welcome from "../views/Welcome";
import Home from '../views/Home.vue';
import CinemaInfo from "../views/cinema/CinemaInfo";
import MovieInfo from "../views/movie/MovieInfo";
import MovieCategory from "../views/movie/MovieCategory";
import HallInfo from "../views/hall/HallInfo";
import SessionInfo from "../views/hall/SessionInfo";
import BillInfo from "../views/bill/BillInfo";
import UserInfo from "../views/user/UserInfo";
import RoleInfo from "../views/role/RoleInfo";
import ResourceInfo from "../views/role/ResourceInfo";
import SystemConfig from "../views/system/SystemConfig";
import FinanceOverview from "../views/finance/FinanceOverview";
import FinanceLedger from "../views/finance/FinanceLedger";
import ExpenseManagement from "../views/finance/ExpenseManagement";
import ArchitectureDemo from "../views/ArchitectureDemo";
import Error404 from "../views/Error404";

Vue.use(VueRouter)

// 添加调试信息
console.log('🔧 加载路由配置...');
console.log('📁 财务管理组件导入状态:', {
  FinanceOverview: !!FinanceOverview,
  FinanceLedger: !!FinanceLedger,
  ExpenseManagement: !!ExpenseManagement
});

const routes = [
  {
    path: '/',
    component: Login,
    redirect: '/login'
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/home',
    component: Home,
    redirect: '/welcome',
    children: [
      { path: '/welcome', component: Welcome },
      { path: '/cinema', component: CinemaInfo, meta: { btnPermission: 'admin' }},
      { path: '/movie', component: MovieInfo, meta: { btnPermission: 'admin' }},
      { path: '/movieCategory', component: MovieCategory, meta: { btnPermission: 'admin' }},
      { path: '/hall', component: HallInfo, meta: { btnPermission: 'admin' }},
      { path: '/session', component: SessionInfo, meta: { btnPermission: 'admin' }},
      { path: '/user', component: UserInfo, meta: { btnPermission: 'admin' }},
      { path: '/bill', component: BillInfo, meta: { btnPermission: 'admin' }},
      { path: '/financeOverview', component: FinanceOverview, meta: { btnPermission: 'admin' }},
      { path: '/financeLedger', component: FinanceLedger, meta: { btnPermission: 'admin' }},
      { path: '/expenseManagement', component: ExpenseManagement, meta: { btnPermission: 'admin' }},
      // 添加路径别名和重定向，匹配菜单数据中的路径
      { path: '/ledger', redirect: '/financeLedger' },
      { path: '/finance', redirect: '/financeOverview' },
      { path: '/expense', redirect: '/expenseManagement' },
      { path: '/statistics', redirect: '/financeOverview' },
      { path: '/role', component: RoleInfo, meta: { btnPermission: 'admin' }},
      { path: '/resource', component: ResourceInfo, meta: { btnPermission: 'admin' }},
      { path: '/systemConfig', component: SystemConfig, meta: { btnPermission: 'admin' }},
      { path: '/architectureDemo', component: ArchitectureDemo, meta: { btnPermission: 'admin' }}
    ]
  },
  {
    path: '/*',
    component: Error404
  }
]

const router = new VueRouter({
  routes,
  mode: 'hash',  // 使用hash模式避免404问题
})

//挂载路由导航守卫
router.beforeEach((to, from, next) =>{
  //to 将要访问的路径
  //from 从哪个页面来
  //next 一个放行函数

  // 添加调试日志
  console.log('🚀 路由导航:', {
    to: to.path,
    from: from.path,
    fullPath: to.fullPath,
    matched: to.matched.length,
    params: to.params,
    query: to.query
  });

  // 专门检查财务管理相关路径
  if (to.path.includes('finance') || to.path.includes('ledger') || to.path.includes('expense') || to.path.includes('statistics')) {
    console.log('💰 财务管理路径导航:', {
      originalPath: to.path,
      isRedirect: to.redirectedFrom,
      matchedRoutes: to.matched.map(m => m.path)
    });
  }

  if(to.path === '/login' || to.path === '/404') {
    console.log('✅ 直接放行登录或404页面');
    return next();
  }

  //顶部进度条
  NProgress.start()
  //获取token
  const token = window.sessionStorage.getItem("token")
  if(!token){
    console.log('❌ 未找到token，跳转登录');
    Message.error('抱歉，请先登录')
    return next('/login');
  }
  console.log('✅ token验证通过，继续导航');
  next();
})

router.afterEach(() => {
  NProgress.done()
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location){
  return originalPush.call(this, location).catch(err => err)
}


export default router
